import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AccountService } from '@clickd-angular/common-lib';

@Injectable({ providedIn: 'root' })
export class AddCommonQueryStringParamsToMscrmappApisInterceptor implements HttpInterceptor {

  constructor(private accountService: AccountService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('api/Editors_v2') || req.url.includes('api/FileManager_v2')) {
      const sessionParams = req.params
        .append('accountKey', this.accountService.accountKey)
        .append('userlcid', this.accountService.userlcid);

      const withSessionInfoReq = req.clone({ params: sessionParams });
      return next.handle(withSessionInfoReq);
    }
    return next.handle(req);
  }
}
